import React from 'react';


import "./HeadPane.scss";

import { PageMenu } from './PageMenu/PageMenu';
import { Link } from '@randajan/jet-react/dom/link';


import { User } from '../Oauth/User';
import { page } from '../../assets/bases/page';
import { Locale } from '../../assets/Locale';
import { ImgStore } from '../../elements/ImgStore/ImgStore';


export const HeadPane = (props)=>{
    const { } = props;
    const say = Locale.use();
    const onLogin = ()=>{ page.set("hash.sign", "up"); }
    const onProfile = ()=>{ page.set("pathname", "/me"); }
    
    return (
        <nav className="HeadPane">
            <Link className="logo" to="/"><ImgStore alt={say.or("headLogoAlt", "Blimp")} src={"logotypeDarkTransparent.svg"}/></Link>
            <div className="right">
                <User onLogin={onLogin} onProfile={onProfile}/>
                <PageMenu/>
            </div>
        </nav>
    )
}
